<template>
    <!-- Country -->
    <div class="form-group focused">
        <div class="custom-selectt">
            <label for="state">{{ props.label }}</label>
            <select id="state" v-model="state" class="form-control" @blur="onBlur" @focus="onFocus"
                @change="emit('change', state)" data-value="shortcode" :data-default-option="placeholder"
                autocomplete="address-level1" :class="{ 'error': props.valid.$errors.length }" />
        </div>
        <span v-if="props.valid.$errors.length" class="error-message">
            {{ props.valid.$errors[0].$message }}
        </span>
    </div>
</template>

<script setup>
import { ref, nextTick } from 'vue'
import { onBlur, onFocus } from './fields.js'

const props = defineProps({
    label: String,
    placeholder: String,
    valid: Object,
    defaultValue: String
})

const emit = defineEmits(['change'])
const state = ref(props?.defaultValue)

nextTick(() => {
    window.crs.init()
    emit('change', state.value)
})
</script>
